import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { NoMouseScrollModule } from "../../directives/no-mouse-scroll/no-mouse-scroll.module";
import { FutureCartComponent } from "./future-cart.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";




@NgModule({
  declarations: [FutureCartComponent],
  imports: [
    CommonModule,
    NgSelectModule,
    NoMouseScrollModule,
    NgbModule
  ],
  exports: [FutureCartComponent]
})
export class FutureCartModule { }
